import { render, staticRenderFns } from "./lightbox-edit.vue?vue&type=template&id=6fac5917&scoped=true&"
import script from "./lightbox-edit.vue?vue&type=script&lang=js&"
export * from "./lightbox-edit.vue?vue&type=script&lang=js&"
import style0 from "./lightbox-edit.vue?vue&type=style&index=0&id=6fac5917&prod&scoped=true&lang=css&"
import style1 from "./lightbox-edit.vue?vue&type=style&index=1&id=6fac5917&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fac5917",
  null
  
)

export default component.exports